import PropTypes from "prop-types";
import HorizontalScrollList from "../../HorizontalScrollList";
import CategoryLinksList from "./CategoryLinksList";
import styles from "./CategoryHeaderLinks";
import { getCategoryLinks } from "../helpers";

const CategoryHeaderLinks = ({ childLinks, siblingLinks, relatedLinks }) => {
  if (
    childLinks.length === 0 &&
    siblingLinks.length === 0 &&
    relatedLinks.length === 0
  ) {
    return null;
  }

  const links = getCategoryLinks(childLinks, siblingLinks, relatedLinks);

  return (
    <HorizontalScrollList
      scrollSnapping={false}
      className={styles.categoryHeaderLinks}
    >
      <CategoryLinksList links={links} />
    </HorizontalScrollList>
  );
};

CategoryHeaderLinks.propTypes = {
  childLinks: PropTypes.arrayOf(
    PropTypes.shape({
      friendlyName: PropTypes.string.isRequired,
      linkUrl: PropTypes.string.isRequired
    })
  ).isRequired,
  siblingLinks: PropTypes.arrayOf(
    PropTypes.shape({
      friendlyName: PropTypes.string.isRequired,
      linkUrl: PropTypes.string.isRequired,
      isCurrentCategory: PropTypes.bool
    })
  ).isRequired,
  relatedLinks: PropTypes.arrayOf(
    PropTypes.shape({
      friendlyName: PropTypes.string.isRequired,
      linkUrl: PropTypes.string.isRequired
    })
  )
};
CategoryHeaderLinks.defaultProps = {
  relatedLinks: []
};
export default CategoryHeaderLinks;
